// extracted by mini-css-extract-plugin
module.exports = {"container":"managerMenu_container__1En_u"};